/**
 * Valide les données d'un formulaire de recette.
 * Fonction pure — ne dépend ni de React ni de Firebase.
 *
 * @param {string} recipeName - Nom de la recette
 * @param {string|number} servings - Nombre de personnes (peut être vide)
 * @param {Array} ingredients - Tableau d'ingrédients avec champ `name`
 * @returns {{ valid: boolean, error: string|null }}
 */
export const validateRecipeForm = (recipeName, servings, ingredients) => {
  if (!recipeName || !recipeName.trim()) {
    return { valid: false, error: 'Veuillez entrer un nom pour la recette' };
  }

  if (servings && (isNaN(servings) || parseInt(servings) < 0)) {
    return { valid: false, error: 'Le nombre de personnes doit être un nombre positif' };
  }

  const hasEmptyIngredient = ingredients.some(ing => !ing.name.trim());
  if (hasEmptyIngredient) {
    return { valid: false, error: 'Tous les ingrédients doivent avoir un nom' };
  }

  return { valid: true, error: null };
};
